export type Password = string;
export const PATTERN =
  /^[a-zA-Z0-9°!"§$%&/()=?`^{}´+~#<>|;:,._\-²³@µüöäÜÖÄß'*\\\\]*$/;
export const MIN_LENGTH = 12;
export const MAX_LENGTH = 32;

export const checkPasswordComplexity = (password: string) => {
  let complexity = 0;

  if (/[A-Z]/.test(password)) {
    complexity++;
  }

  if (/[a-z]/.test(password)) {
    complexity++;
  }

  if (/[0-9]/.test(password)) {
    complexity++;
  }

  if (/[°!"§$%&/()=?`^{}\\´+~#<>|;:,._²³@€µüöäÜÖÄß'*-]/.test(password)) {
    complexity++;
  }

  if (complexity >= 3) {
    return true;
  }

  return false;
};
